// Framework
import Raven from 'raven-js';

// Actions
export const FETCH_USERS_REQUEST = 'COMMUNICATION/FETCH_USERS_REQUEST';
export const FETCH_USERS_SUCCESS = 'COMMUNICATION/FETCH_USERS_SUCCESS';
export const FETCH_USERS_ERROR = 'COMMUNICATION/FETCH_USERS_ERROR';

export const FETCH_THREAD_REQUEST = 'COMMUNICATION/FETCH_THREAD_REQUEST';
export const FETCH_THREAD_SUCCESS = 'COMMUNICATION/FETCH_THREAD_SUCCESS';
export const FETCH_THREAD_ERROR = 'COMMUNICATION/FETCH_THREAD_ERROR';

export const SELECT_USER = 'COMMUNICATION/SELECT_USER';

export const TOGGLE_SEND_INPUT = 'COMMUNICATION/MESSAGES/TOGGLE_SEND_INPUT';

/*** Action Creators ***/
export const selectUser = (currentUser) => ({
  type: SELECT_USER,
  currentUser
});

export const fetchUsersSuccess = (users) => ({
  type: FETCH_USERS_SUCCESS,
  users
});

export const fetchUsersError = (error) => ({
  type: FETCH_USERS_ERROR,
  error
});

export const fetchThreadSuccess = (messages) => ({
  type: FETCH_THREAD_SUCCESS,
  messages
});

export const fetchThreadError = (error) => ({
  type: FETCH_THREAD_ERROR,
  error
});

export const toggleSendInput = (sendInputActive) => ({
  type: TOGGLE_SEND_INPUT,
  sendInputActive
});

/*** Reducer ***/
export const DEFAULT_STATE = {
  messages: [],
  users: [],
  currentUser: 0,
  error: null,
  sendInputActive: false
};

export default function MessagesReducer(
  state = DEFAULT_STATE,
  { users, currentUser, messages, sendInputActive, error, type } = {}
) {
  switch (type) {
    case SELECT_USER:
      return {
        ...state,
        currentUser,
        sendInputActive: false
      };
    case FETCH_THREAD_SUCCESS:
      return {
        ...state,
        messages
      };
    case FETCH_USERS_SUCCESS:
      return {
        ...state,
        users
      };
    case FETCH_USERS_ERROR:
    case FETCH_THREAD_ERROR:
      Raven.captureException(error, { state });
      return {
        ...DEFAULT_STATE,
        error
      };
    case TOGGLE_SEND_INPUT:
      return {
        ...state,
        sendInputActive
      };
    case FETCH_USERS_REQUEST:
    case FETCH_THREAD_REQUEST:
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/actions/communication/messages/actions.js